import { render, staticRenderFns } from "./SystemDictionary.vue?vue&type=template&id=21f50721&"
import script from "./SystemDictionary.vue?vue&type=script&lang=js&"
export * from "./SystemDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports